import React from 'react'
import cn from 'classnames'

import { TypeItemCtaGroup, CtaGroupLayout, CtaDescriptionPosition } from '../../../lib/types'
import { ContentProps, ContentRenderer } from '../../renderer'
import { useGetAuthAndDeviceTypeCta } from '../../../lib/hooks/auth-and-device-type-cta'

import styles from './cta-group.module.scss'
import {
  CtaButtonMetadataProvider,
  DefaultCtaButtonContext,
  useCtaButtonMetadata,
} from '../../../contexts/cta-button-context'
import { CtaButtonDescription } from '../cta-button'
import { isTypeComponentEmptyStub } from '@lib/types/content-types'

export const ItemCtaGroup: React.FC<ContentProps<TypeItemCtaGroup>> = (props) => {
  const {
    structure: {
      fields: { ctAs, layout = CtaGroupLayout.Row, internalName },
    },
  } = props

  const { getAuthAndDeviceTypeCta } = useGetAuthAndDeviceTypeCta()
  const { showCtaDescription } = useCtaButtonMetadata()
  const authAndDeviceTypeCtas = ctAs.map(getAuthAndDeviceTypeCta).filter((cta) => !isTypeComponentEmptyStub(cta))
  const firstCtaWithDescription = authAndDeviceTypeCtas.find((cta) => cta.fields.ctaUnderDescription != undefined)
  return (
    <>
      <div
        className={cn(styles.container, layout === CtaGroupLayout.Column ? styles.column : styles.row)}
        data-component-id={internalName}
      >
        {authAndDeviceTypeCtas.map((cta) => (
          <CtaButtonMetadataProvider
            key={cta.sys.id}
            value={{
              ...DefaultCtaButtonContext,
              showCtaDescription: false,
              descriptionPosition: CtaDescriptionPosition.Left,
            }}
          >
            <ContentRenderer key={cta.sys.id} structure={cta} />
          </CtaButtonMetadataProvider>
        ))}
      </div>
      {showCtaDescription && firstCtaWithDescription ? (
        <CtaButtonDescription structure={firstCtaWithDescription} />
      ) : (
        <></>
      )}
    </>
  )
}
